import { differenceInMilliseconds } from 'date-fns';

import { constants, getIngestionDateFromStatementId } from '.';

const { INGESTION_TIMEOUT_MS } = constants;

/**
 * Given a statement Id, return true if the statement has timed out, i.e. it has been longer than
 * INGESTION_TIMEOUT_MS since it was ingested.
 *
 * A statementId includes a Unix epoch timestamp for its first 10 characters.
 * @param statementId
 */
export const statementHasTimedOut = (statementId: Maybe<string>): boolean => {
    if (statementId === null) {
        return false;
    }

    const statementDate = getIngestionDateFromStatementId(statementId);

    if (statementDate === null) {
        return false;
    }

    const now = new Date();

    const ageInMilliseconds = differenceInMilliseconds(now, statementDate);

    if (ageInMilliseconds > INGESTION_TIMEOUT_MS) {
        return true;
    }

    return false;
};
